(() => {
  if (document.documentElement.lang !== 'ar') return;

  function start() {
    const root = document.querySelector('.smkb');
    if (!root || root.dataset.arHelpSearch === 'ready') return;
    const input = root.querySelector('#smkb-search-input');
    const clear = root.querySelector('#smkb-clear');
    const status = root.querySelector('#smkb-status');
    const empty = root.querySelector('#smkb-empty');
    const sections = Array.from(root.querySelectorAll('.smkb-faq-section'));
    const questions = Array.from(root.querySelectorAll('.smkb-question'));
    if (!input || !clear || !status || !empty || !questions.length) return;

    const normalize = (text) => text.normalize('NFKC')
      .replace(/[\u064b-\u065f\u0670\u0640]/g, '')
      .replace(/[\u2010-\u2015\u2212]/g, '-')
      .replace(/wi[\s-]*fi/gi, 'wifi')
      .toLocaleLowerCase('ar').replace(/\s+/g, ' ').trim();
    const entries = questions.map((question) => ({
      question,
      text: normalize(question.textContent),
    }));

    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');

    function filter(moveToFirst = false) {
      const query = normalize(input.value);
      const terms = query.split(' ').filter(Boolean);
      const matches = [];
      entries.forEach(({ question, text }) => {
        const match = terms.every((term) => text.includes(term));
        question.hidden = !match;
        question.classList.toggle('is-match', Boolean(query) && match);
        if (match) matches.push(question);
      });
      sections.forEach((section) => {
        section.hidden = !matches.some((question) => section.contains(question));
      });
      clear.hidden = !query;
      empty.hidden = !query || matches.length > 0;
      status.textContent = query ? `عدد الإجابات المطابقة: ${matches.length}` : '';
      if (moveToFirst && query && matches.length) {
        const first = matches[0];
        first.open = true;
        const summary = first.querySelector('summary');
        summary?.focus({ preventScroll: true });
        summary?.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'center',
        });
      }
      return matches;
    }

    function reset() {
      input.value = '';
      filter();
      input.focus();
    }

    input.addEventListener('input', () => filter());
    input.addEventListener('search', () => filter());
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        filter(true);
      } else if (event.key === 'Escape' && input.value) {
        event.preventDefault();
        reset();
      }
    });
    clear.addEventListener('click', reset);
    root.querySelectorAll('.smkb-popular button').forEach((button) => {
      button.addEventListener('click', () => {
        input.value = button.textContent.trim();
        input.focus({ preventScroll: true });
        filter(true);
      });
    });
    root.querySelectorAll('.smkb-cat[href^="#"]').forEach((link) => {
      link.addEventListener('click', () => {
        input.value = '';
        filter();
        const section = sections.find((item) => `#${item.id}` === link.getAttribute('href'));
        if (section) {
          if (!section.hasAttribute('tabindex')) section.tabIndex = -1;
          section.focus({ preventScroll: true });
        }
      });
    });
    root.dataset.arHelpSearch = 'ready';
    filter();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
